import { connect } from 'react-redux';

const mapStateToProps = ({ CategoriesData }) => ({ CategoriesData });

export default (WrappedComponent) => connect(mapStateToProps, {})(WrappedComponent);
